module.exports = __webpack_public_path__ + "img/5fe8856.png";